import { MessageCircle } from "lucide-react"
import { formatDistanceToNow } from "date-fns"

import { FeatureCard } from "./feature-card"
import type { DashboardConversation } from "@/types"

interface ConversationsCardProps {
  conversations: DashboardConversation[]
  animationDelay?: number
}

export function ConversationsCard({
  conversations,
  animationDelay = 0,
}: ConversationsCardProps) {
  return (
    <FeatureCard
      title="Conversations"
      icon={MessageCircle}
      iconColor="text-emerald-600 dark:text-emerald-400"
      iconBgColor="bg-emerald-100 dark:bg-emerald-900/30"
      href="/conversations"
      animationDelay={animationDelay}
    >
      {conversations.length === 0 ? (
        <div className="py-4 text-center">
          <p className="text-muted-foreground text-sm">No conversations yet</p>
          <p className="text-muted-foreground mt-1 text-xs">
            Start practicing Thai!
          </p>
        </div>
      ) : (
        <ul className="space-y-3">
          {conversations.slice(0, 4).map((conversation) => (
            <li
              key={conversation.id}
              className="bg-muted/30 hover:bg-muted/50 flex items-center justify-between gap-3 rounded-lg px-3 py-2 transition-colors"
            >
              <div className="min-w-0 flex-1">
                <p className="text-foreground truncate text-sm font-medium">
                  {conversation.title}
                </p>
                <p className="text-muted-foreground text-xs">
                  {conversation.messageCount} message
                  {conversation.messageCount !== 1 ? "s" : ""}
                </p>
              </div>
              <span className="text-muted-foreground shrink-0 text-xs">
                {formatDistanceToNow(new Date(conversation.updatedAt), {
                  addSuffix: true,
                })}
              </span>
            </li>
          ))}
        </ul>
      )}
    </FeatureCard>
  )
}
